import { render, staticRenderFns } from "./JobsDatatable.vue?vue&type=template&id=62d55c16&"
import script from "./JobsDatatable.vue?vue&type=script&lang=js&"
export * from "./JobsDatatable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports